import { v4 as uuidv4 } from 'uuid';

export default () => {
  const uuid = uuidv4()
  return {
    $id: uuid,
    valueType: 'password',
    FormItemProps: {
      label: '密码',
      name: uuid,
    }
  }
};
